import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'

const ImageBar = ({isHome}) => (
    <StaticQuery
    query={graphql`
        {
            background: file(relativePath: { eq: "IMG_4763.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 1920, maxHeight: 950, cropFocus: CENTER, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                }
            }
        }
    `}
    render={ data => (
        <Img fluid={data.background.childImageSharp.fluid} alt="" className={`imageBar ${isHome ? 'is-home' : ''}`} />
    )}
    />
)

export default ImageBar